import { render, staticRenderFns } from "./BusinessFooter.vue?vue&type=template&id=185c6fb6&"
import script from "./BusinessFooter.vue?vue&type=script&lang=js&"
export * from "./BusinessFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports